import { motion } from "framer-motion";
import { waLink, ease } from "./constants";
import { WhatsAppIcon } from "./Icons";
import { Reveal } from "./Reveal";

export const QuoteCta = () => (
  <section className="relative overflow-hidden bg-[#0c0a09] py-28 sm:py-36" data-testid="quote-cta-section">
    <div style={{ backgroundImage: "url(/img/about.jpg)" }} className="wood-side absolute inset-y-0 left-0 w-1/3 bg-cover bg-center opacity-30" />
    <div style={{ backgroundImage: "url(/img/about.jpg)" }} className="wood-side-r absolute inset-y-0 right-0 w-1/3 bg-cover bg-center opacity-30" />
    <div className="grain absolute inset-0" />
    <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#FACC15]">Orçamento rápido</p>
        <h2 className="font-display mt-6 text-5xl font-black uppercase leading-[0.88] text-white sm:text-7xl lg:text-8xl">
          Precisa de compensado <span className="text-[#FACC15]">para sua obra?</span>
        </h2>
        <p className="mx-auto mt-8 max-w-xl text-base text-stone-300 sm:text-lg">Fale com a Destak e consulte preços, disponibilidade e condições.</p>
      </Reveal>
      <Reveal delay={0.15}>
        <motion.a whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }} transition={{ ease }} href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn" className="group relative mt-12 inline-flex items-center gap-4 rounded-full bg-[#FACC15] px-8 py-5 font-display text-xl font-black uppercase tracking-wide text-[#0c0a09] shadow-[0_0_0_0_rgba(250,204,21,0.5)] transition-shadow duration-500 hover:shadow-[0_0_0_14px_rgba(250,204,21,0.15)] sm:px-12 sm:py-6 sm:text-2xl">
          <span className="grid h-10 w-10 place-items-center rounded-full bg-[#0c0a09] text-[#FACC15]"><WhatsAppIcon className="h-5 w-5" /></span>
          Pedir orçamento pelo WhatsApp
        </motion.a>
      </Reveal>
    </div>
  </section>
);
